import {useEffect, useState} from 'react'
import {useAuth} from '../../hooks/useAuth'
import SplashScreen from '../splash/SplashScreen'
import React from 'react'

interface AppInitializerProps {
    children: React.ReactNode;
}

const AppInitializer: React.FC<AppInitializerProps> = ({children}) => {
    const {isInitializing} = useAuth()
    const [minTimeElapsed, setMinTimeElapsed] = useState(false)

    // Ensure splash screen displays for at least 750ms to prevent jarring flashes
    useEffect(() => {
        const timer = setTimeout(() => {
            setMinTimeElapsed(true)
        }, 750)

        return () => clearTimeout(timer)
    }, [])

    if (isInitializing || !minTimeElapsed) {
        return <SplashScreen/>
    }

    return <>{children}</>
}

export default AppInitializer
